import React, {useContext} from 'react';
import './ActiveOrderList.less';
import {OrderCard} from "compositions/order-card/OrderCard";
import {Indicator, IndicatorTypes} from "elements/indicator/Indicator";
import {List} from "elements/list/List.tsx";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";
import {Button} from "../../elements/button/Button";
import {getItemStringFromOrder} from "../../../helpers/order.helper";

export const ActiveOrderList = ({activeOrders, onOrderClick, onOrderAgainClick}) => {

	const translations = useContext(TranslationsContext);

	return <List>
		{
			activeOrders.map((activeOrder, index) => <ListItem key={activeOrder.orderId}
																												 onClick={() => onOrderClick(activeOrder.orderId)}>
				<OrderCard
					restaurantName={activeOrder.restaurantName}
					status={getSafeTranslation(activeOrder.statusString, translations)}
					date={activeOrder.placedAt.date}
					totalPrice={activeOrder.total}
					itemsString={getItemStringFromOrder(activeOrder)}
					indicatorControl={<Indicator type={IndicatorTypes.SUCCESS}/>}
					actionControl={<Button
						isAutoWidth
						onClick={(event) => {
							event.stopPropagation();
							onOrderAgainClick(activeOrder)
						}}
					>
						{getSafeTranslation('ActiveOrderList.repeatOrderButtonCaption', translations)}
					</Button>}
				/>
			</ListItem>)
		}
	</List>
}
